import React from 'react';
import ONCRP_TOOLS_QP_Card from './OncoRiskCard';
import { KeyValue, TagList } from './CommonComponents';

const ColocatedVariantsCard = ({ vepData }) => {
    if (!vepData || !vepData.colocated_variants) return null;

    return (
        <ONCRP_TOOLS_QP_Card title="Colocated Variants & Frequencies" icon="fa-database" className="ONCRP-TOOLS-QP-span-col-6">
            {vepData.colocated_variants.map((cv, i) => (
                <div key={i} className="ONCRP-TOOLS-QP-section">
                    <h4>Variant ID: {cv.id} <span className="ONCRP-TOOLS-QP-tag">{cv.somatic ? 'Somatic' : 'Germline'}</span></h4>
                    <KeyValue label="Allele-Specific Significance">{cv.clin_sig_allele}</KeyValue>
                    <TagList title="Clinical Significance Assertions" items={cv.clin_sig} tagClass="ONCRP-TOOLS-QP-tag-sig" />
                    {cv.frequencies && Object.entries(cv.frequencies).map(([allele, freqs]) => (
                        <div key={allele} className="ONCRP-TOOLS-QP-subsection">
                            <h4>Frequencies for Allele '{allele}' (gnomAD)</h4>
                            <div className="ONCRP-TOOLS-QP-kv-grid five-column-grid">
                                {Object.entries(freqs).map(([pop, freq]) => (
                                    <KeyValue key={pop} label={pop.replace('gnomade_', ' ')}>{typeof freq === 'number' ? freq.toExponential(2) : freq}</KeyValue>
                                ))}
                            </div>
                        </div>
                    ))}
                    {cv.var_synonyms && Object.entries(cv.var_synonyms).map(([db, ids]) => (
                        <TagList key={db} title={`${db} Synonyms`} items={ids} tagClass="ONCRP-TOOLS-QP-tag-pred" />
                    ))}
                    <TagList title="Associated PubMed IDs" items={cv.pubmed} createLink={(pmid) => `https://pubmed.ncbi.nlm.nih.gov/${pmid}`} tagClass="ONCRP-TOOLS-QP-tag-direction"/>
                </div>
            ))}
        </ONCRP_TOOLS_QP_Card>
    );
};

export default ColocatedVariantsCard; 